import Cookie from 'js-cookie';
import { getDomain } from './getDomain';

const COOKIE_NAME = 'wtv_last_visit';

export function createLastVisitCookie() {
  const domain = getDomain();

  const cookieValue = new Date().getTime();

  Cookie.set(COOKIE_NAME, cookieValue, {
    domain,
    expires: 2 * 365,
  });
}
